export default "__VITE_PUBLIC_ASSET__62806fd0__"